export default __webpack_public_path__ + "static/media/567.266a10d3.png";